/**
 *
 * riskview service
 */

import { apiConfig, createAxiosServiceInstance } from '../api';

import moment from 'moment';

import { convertToUtcTime } from '../../util/index';
import { dateTimeFormat } from '../../util/GlobalConstant';
import { AMLS_NS_SAM } from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();
const baseUrl = `${apiConfig.serviceApi}${AMLS_NS_SAM}/riskview`;

const headers = {
  'Content-Type': 'application/json'
};

export async function getFigureData(payload) {
  const { from, to } = payload;
  let url = `${baseUrl}/alertStatistic`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getAlertsAndHitsChart(payload) {
  const { from, to } = payload;
  let url = `${baseUrl}/alertsAndHits`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getHitYieldChart(payload) {
  const { from, to } = payload;
  let url = `${baseUrl}/hitYield`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data.map((o) => {
        return {
          ...o,
          date: moment
            .utc(o.date, [dateTimeFormat])
            .local()
            .format('DD/MM/YYYY')
        };
      });
    })
    .catch((err) => {
      throw err;
    });
}

export async function getHitsDistributionChart(payload) {
  const { from, to } = payload;
  let url = `${baseUrl}/hitsDistribution`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getSegments(payload) {
  const { from, to } = payload;
  let url = `${apiConfig.serviceApi}${AMLS_NS_SAM}/segments`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data.map((o) => {
        return {
          code: o.code,
          id: o.code,
          name: o.name
        };
      });
    })
    .catch((err) => {
      throw err;
    });
}

export async function getCustomerViewData(payload) {
  const { from, to } = payload;
  let url = `${baseUrl}/customersView`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}

export async function getBusinessSegmentsParametersData(payload) {
  const { from, to, segmentCode } = payload;
  let url = `${baseUrl}/segmentsAndParametersView`;
  const params = {
    ...payload,
    to: convertToUtcTime(`${to} 23:59:59.999`),
    from: convertToUtcTime(`${from} 00:00:00.000`)
  };

  return await axios
    .get(url, { headers, params })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
}
